import { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';

import { useLocale } from '@shared/hooks/locale';

import { DashboardFeed } from './DashboardFeed';

type CollapsibleFeedProps = {
  showHeader?: boolean;
};

export const CollapsibleFeed = ({
  showHeader = false,
}: CollapsibleFeedProps) => {
  const { t } = useLocale();
  const [showFeed, setShowFeed] = useState(false);

  const button = (
    <Button
      size="small"
      variant="text"
      onClick={() => setShowFeed(prev => !prev)}
      endIcon={showFeed ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      sx={{
        ...(!showHeader && { alignSelf: 'flex-start' }),
        color: 'text.secondary',
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': { color: 'primary.main' },
      }}
    >
      {showFeed ? t('Hide activity feed') : t('Show activity feed')}
    </Button>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {showHeader ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pt: 1,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {t('Activity feed')}
          </Typography>
          {button}
        </Box>
      ) : (
        button
      )}
      {showFeed && <DashboardFeed />}
    </Box>
  );
};
